import { Mission } from "../components/pages/about/Mission";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import BannerOverlay from "../components/BannerOverlay";

const About = () => {
    return (
        <div className="m-0 p-0" style={{ background: "var(--brand-black)" }}>
            <Header />
            <BannerOverlay
                imageUrl="https://ik.imagekit.io/dnddecpho/dndream/D&D_Website_WebBanner_1920x500px_PC_XVIqN6YlI7.jpg?updatedAt=1731826250727"
                title=""
            />
            <div className="media-band">
                <img
                    src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteIcons-15_LsMwLmh0U.gif?updatedAt=1719656047744"
                    alt="About"
                />
            </div>
            <Mission />
            <div
                className="partners-section"
                style={{
                    background: "#ffffff",
                    padding: "3.5rem 0 4rem",
                }}
            >
                <div
                    className="section-block"
                    style={{ paddingBottom: "1.5rem" }}
                >
                    <h2 className="section-title">OUR PARTNERS</h2>
                </div>
                <div className="media-band" style={{ background: "#ffffff" }}>
                    <img
                        src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteIcons-17_TBOItTZQB.gif?updatedAt=1719760888630"
                        alt="Partners"
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default About;
